<template>
  <div class="custom-select__button">
    <label class="input__select">
      <input
        :class="{ open: open }"
        type="text"
        @focus="open = true"
        @blur="handleBlur"
        @input="updateSelected($event.target.value)"
        :placeholder="placeholder_title"
        :value="internalSelected"
      >
      <div v-if="!internalSelected">
        <svg width="20.000000" height="20.000000" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <defs>
            <clipPath id="clip12_1054">
              <rect id="Arrows" rx="0.000000" width="19.000000" height="19.000000" transform="translate(0.500000 0.500000)" fill="white" fill-opacity="0"/>
            </clipPath>
          </defs>
          <rect id="Arrows" rx="0.000000" width="19.000000" height="19.000000" transform="translate(0.500000 0.500000)" fill="#FFFFFF" fill-opacity="0"/>
          <g clip-path="url(#clip12_1054)">
            <path id="Vector" d="M14.5 7.5L9.5 12.5L4.5 7.5" stroke="#050505" stroke-opacity="1.000000" stroke-width="1.300000" stroke-linejoin="round" stroke-linecap="square"/>
          </g>
        </svg>
      </div>
      <div
        class="clear"
        v-if="internalSelected"
        @click="clearSelection"
        >
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M15.4124 5.70711C15.803 5.31658 15.803 4.68342 15.4124 4.29289C15.0219 3.90237 14.3887 3.90237 13.9982 4.29289L9.85222 8.43889L5.70735 4.29403C5.31683 3.90351 4.68366 3.90351 4.29314 4.29403C3.90262 4.68455 3.90262 5.31772 4.29314 5.70824L8.438 9.85311L4.29314 13.998C3.90261 14.3885 3.90261 15.0217 4.29314 15.4122C4.68366 15.8027 5.31683 15.8027 5.70735 15.4122L9.85222 11.2673L13.9982 15.4133C14.3887 15.8039 15.0219 15.8039 15.4124 15.4133C15.803 15.0228 15.803 14.3896 15.4124 13.9991L11.2664 9.85311L15.4124 5.70711Z"
            fill="#292929" />
        </svg>
      </div>
    </label>
    <div class="items" v-if="sort.length > 0" :class="{ open: open }">
      <div v-for="option in sort" :key="option.id" @click="handleOptionClick(option)">
        {{ option[data_name] }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Select',
  props: {
    modelValue: [Number, String],
    sort: {
      type: Array,
      default: () => [],
    },
    data_name: String,
    selected: [String, Number],
  },
  data() {
    return {
      open: false,
      internalSelected: null,
    };
  },
  watch: {
    selected: {
      immediate: true,
      handler(newValue) {
        this.internalSelected = newValue;
      },
    },
  },
  methods: {
    updateSelected(value) {
      this.internalSelected = value;
      this.$emit('search', value);
    },
    handleOptionClick(option) {
      this.internalSelected = option[this.data_name];
      this.open = false;

      // Уведомляем об изменении `modelValue`
      if (option.event_id) {
        this.$emit('update:modelValue', { id: option.id, event_id: option.event_id });
      } else {
        this.$emit('update:modelValue', option.id);
      }

    },
    clearSelection() {
      this.internalSelected = '';
      this.$emit('update:modelValue', '');
    },
    handleBlur() {
      setTimeout(() => (this.open = false), 200); // Закрытие с задержкой
    },
  },
};
</script>

<style>
.custom-select__button {
  position: relative;
}

.custom-select__button.error input {
  border-radius: 8px;
  border: 1.5px solid var(--Red-200, #EA2313);
}

.custom-select__button.p-reletive {
  position: relative;
}

.custom-select__button.p-reletive .items {
  position: absolute;
  z-index: 2;
}

.input__select {
  position: relative;
}

.input__select input {
  border-radius: 8px;
  border: 1.5px solid #E5E5EA;
  height: 50px;
  width: 100%;
  padding: 9px 12px;
}

.custom-select__button .items {
  display: none;
}

.custom-select__button .items.open {
  display: block;
  max-height: 300px;
  overflow-y: auto;
}

.custom-select__button.h-40 input {
  height: 40px;
}

.input__select>div {
  position: absolute;
  top: 0;
  right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}

.items {
  position: absolute;
  z-index: 10;
  top: calc(100% + 8px);
  border-radius: 8px;
  border: 1.5px solid #CCC;
  background: #FFF;
  width: 100%;
  padding: 8px;
  margin-top: 8px;
}

.items>div {
  cursor: pointer;
  padding: 8px;
  color: #292929;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.09px;
}

.items>div:hover {
  background: #F5F5F5;
}

.input__filter__wrapper .items.open {
  display: block;
  z-index: 2;
}
</style>